import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Carousels from './carousel';
import Footer from './footer';
import Navbars from './Navbar';

const Importresult = () => {
const location = useLocation();
const navigate = useNavigate();
const [selectedCbeNo, setSelectedCbeNo] = useState(null);
  if (!location.state) {
    return <div className="text-center mt-5">CBE not filed. Please search again.</div>;
  }
  const {
    importDetails,
    hawbNo,
    courierName,
    errorMessage,
    status,
    cbeNoList,
    multipleImport,
    importDetailsList = {},
    errorList,
  } = location.state;

  const mergedData = {
    ...importDetails,
    hawbNo,
    courierName,
  };

  const displayFields = [
    { fieldKey: "cbeNo", label: "BOE No" },
    { fieldKey: "cbeDate", label: "CBE Filed Date" },
    { fieldKey: "assessableValue", label: "Assessable Value" },
    { fieldKey: "totalDuty", label: "Total Custom Duty" },
    { fieldKey: "status", label: "Current Status" },
    { fieldKey: "detail_description", label: "Detail Description about Current Status" },
    { fieldKey: "modified_date", label: "Status Date" },
    { fieldKey: "hawbNo", label: "HAWB NO" },
    { fieldKey: "courierName", label: "Courier Co" },
  ];

  const handleCbeClick = (cbeNo) => {
  navigate('/cbeDetails', {
    state: { cbeName: cbeNo, hawbNo, courierName }
  });
};

  return (
    <div className="container-fixed">
      <Navbars />
      <Carousels />
      <Container className="mt-4 import-form-carousel">
        <h3 className="text-center mb-4">Import</h3>
        {status === "FAILURE" ? (
          <div className="alert alert-danger text-center">
            {errorList && errorList.length > 0 ? (errorList.map((error, idx) => (
                <div key={idx}>{error}</div>
              ))
            ) : (
              errorMessage || "Error fetching import data."
            )}
 
          </div>
          ) : status === "SUCCESS" && multipleImport === false && (!Array.isArray(cbeNoList) || cbeNoList.length === 0) ? (
          <div className="alert alert-warning text-center">
              CBE not filed. Please search again.
          </div>) : Array.isArray(cbeNoList) && cbeNoList.length > 1 ? (
          <>
            <div>
              <ul className="list-group">
                {cbeNoList.map((cbeNo, idx) => (
                  <li
                    key={idx}
                    className={`list-group-item ${selectedCbeNo === cbeNo ? 'active' : ''}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleCbeClick(cbeNo)}
                  >
                    {cbeNo}
                  </li>
                ))}
              </ul>

              {selectedCbeNo && (
                <div className="mt-4">
                  <table className="table table-bordered table-striped table-sm">
                    <tbody>
                      {displayFields.map(({ fieldKey, label }) => {
                        const detail = importDetailsList[selectedCbeNo] || mergedData;
                        return detail[fieldKey] ? (
                          <tr key={fieldKey}>
                            <td>{label}</td>
                            <td>{detail[fieldKey]}</td>
                          </tr>

                        ) : null;

                      })}
                    </tbody>
                  </table>
                </div>

              )}
            </div>
          </>

        ) : Array.isArray(cbeNoList) && cbeNoList.length === 1 ? (

          <table className="table table-bordered table-striped table-sm">
            <tbody>
              {displayFields.map(({ fieldKey, label }) =>
                mergedData[fieldKey] ? (
                  <tr key={fieldKey}>
                    <td>{label}</td>
                    <td>{mergedData[fieldKey]}</td>
                  </tr>

                ) : null
              )}
            </tbody>
          </table>

        ) : importDetails ? (
          <table className="table table-bordered table-striped table-sm">
            <tbody>
              {displayFields.map(({ fieldKey, label }) =>
                mergedData[fieldKey] ? (
                  <tr key={fieldKey}>
                    <td>{label}</td>
                    <td>{mergedData[fieldKey]}</td>
                  </tr>

                ) : null
              )}
            </tbody>
          </table>
        ) : (
          <div className="text-center">No data available.</div>
        )}
        

        <button type="button" className="btn btn-danger submit-btn return-btn" onClick={() => navigate('/import')}
        >RETURN
        </button>
      </Container>
      <Footer />
    </div>
  );
};
export default Importresult;

